"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeDatePickerStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeDatePickerStyles = function makeDatePickerStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiCalendarPicker: {
      styleOverrides: {
        root: {
          "& .PrivatePickersFadeTransitionGroup-root": _objectSpread(_objectSpread({}, tokens.typography["short-copy-medium"]), {}, {
            fontWeight: primitives.fontWeights.stout,
            "& .MuiButtonBase-root:focus": _objectSpread({}, tokens.effects["focus-ring"])
          }),
          "& > div:nth-of-type(1) > div:nth-of-type(1)": {
            minHeight: "40px",
            paddingRight: "".concat(primitives.spacings["1"])
          },
          "& .MuiTypography-caption": {
            color: tokens.colors["ink-on-background-60"].rgb
          },
          "& .MuiIconButton-root": {
            borderRadius: primitives.borderRadii.round,
            background: primitives.colors.primary.white,
            "&:hover": {
              backgroundColor: tokens.colors["hover-fill-subtle"].rgb
            },
            "&:focus": _objectSpread({
              backgroundColor: primitives.colors.primary.white
            }, tokens.effects["focus-ring"])
          },
          "& svg": {
            color: "black"
          }
        }
      }
    },
    MuiPickersDay: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, tokens.typography["short-copy-medium"]), {}, {
          marginTop: "".concat(primitives.spacings["1"]),
          "&.Mui-selected": {
            fontWeight: primitives.fontWeights.default
          }
        }),
        today: {
          border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-on-background"].color),
          "&:not(.Mui-selected)": {
            border: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["ink-on-background"].color)
          }
        }
      }
    },
    MuiYearPicker: {
      styleOverrides: {
        root: {
          "& button": _objectSpread(_objectSpread({}, tokens.typography["short-copy-medium"]), {}, {
            margin: "".concat(primitives.spacings["1"], " ").concat(primitives.spacings["0"])
          }),
          "& button[disabled]": {
            color: tokens.colors["backdrop-30"].rgb
          },
          "& button[disabled]:hover": {
            backgroundColor: "transparent",
            cursor: "default"
          }
        }
      }
    },
    MuiDateRangePickerViewDesktop: {
      styleOverrides: {
        root: {// placeholder
          // backgroundColor: "#f90"
        }
      }
    }
  };
};

exports.makeDatePickerStyles = makeDatePickerStyles;